import { Pipe, PipeTransform } from '@angular/core';

import { IGroupInCatalogue } from '../../prisma-xs/models/prisma-xs.model';
import { SearchArticlePipe } from '../../ui/pipes/search-article.pipe';

@Pipe({
    name: 'searchGroupedCatalogue',
    standalone: false
})
export class SearchGroupedCataloguePipe implements PipeTransform {

  transform(groupedArticles: IGroupInCatalogue[], searchText: string, __ = false, _?: number): number {
    const searchArticlePipe = new SearchArticlePipe();
    return groupedArticles?.reduce((sum, group) => {
      return sum + searchArticlePipe.transform(group.group.articles, searchText).length;
    }, 0);
  }

  filterCompleteFields(groups: IGroupInCatalogue[], height: number): IGroupInCatalogue[] {
    return groups?.filter( g => g.group?.articles[0]?.widget?.height === height);
  }

}
